
export const Accessiblity = (function () {
	'use strict';

	function init() {
		events();
	}

	function events() {
        document.body.addEventListener('mousedown', function() {
            document.body.classList.add('using-mouse');
        });
        
        document.body.addEventListener('keydown', function() {
            document.body.classList.remove('using-mouse');
        });
    }

	return {
		init: init,
	};
})();
